/**
 * 编组：与 Ctrl/Cmd+G 同能力，挂到图层快捷条。
 */
import { getLocaleStore } from '@/i18n';
import type { IShortcutMenuItemRenderArgs } from '@/plugins/shortcut-menu/type';
import { ShortcutToolbarIconItem } from '@/plugins/shortcut-menu/views/shortcut-toolbar-widgets';
import { type IGroupLayerProps } from '@/version-types';
import { GroupLayerHotkeyType } from '../../../../type';

export const groupPackShortcutItem = ({ framework, layer }: IShortcutMenuItemRenderArgs) => {
    const { $t } = getLocaleStore();
    const isExtraGroup = (layer.data as IGroupLayerProps)?.isExtraGroup;
    if (!isExtraGroup) return null;

    return (
        <ShortcutToolbarIconItem
            name="GroupLinkBold"
            title={$t((v) => v.baseLayer.shortcutOperate.group)}
            onClick={(e) => {
                e.stopPropagation();
                framework.service.hotkey.__emit(GroupLayerHotkeyType.PACK, { from: 'shortcut-menu' });
            }}
        />
    );
};
